<ng-template #emptyproducts>
    <div class="empty">
        <ion-card uppDataid="user-noproducts-warning">
            <ion-icon name="wine-outline"></ion-icon>
            <ion-card-header>
                <ion-card-title>{{tr('@place_products_empty_title')}}</ion-card-title>
            </ion-card-header>
            <ion-card-content>
                {{tr('@place_products_empty_message')}}
            </ion-card-content>
        </ion-card>    
    </div>
</ng-template>

<ng-template #productsgrid>
    <!-- products grid -->
    <ng-container *ngFor="let _group of browser.groups; trackBy: browser.GroupTrack;">
        <upp-grid name="PLACE_SELECT_GRID" [hidden]="browser.parent !== _group.parent">
            <upp-grid-item *ngIf="(place?.ProductCodes || place?.HasCodeScan) && !browser.hasParent && _group.parent === null">
                <upp-product-thumb uppDataid="tabselect-prdno-button" target="PRDNO" (Select)="OnProductCodeSearch()"></upp-product-thumb>
            </upp-grid-item>
            <ng-container *ngIf="!browser.hasParent && _group.parent === null">
                <upp-grid-item *ngFor="let _menu of browser.menus; trackBy: browser.ItemTrack">
                    <upp-offer-thumb [uppDataid]="'tabselect-menu-' + (tr(_menu.name) || '') + '-thumb'"
                        [item]="_menu"
                        (Select)="ticket && browser.OnMenuItem(_menu)"
                    ></upp-offer-thumb>
                </upp-grid-item>
            </ng-container>
            <ng-container *ngFor="let _product of _group.children; trackBy: browser.ItemTrack">
                <upp-grid-item *ngIf="ToProductsGrid(_product)">
                    <upp-product-thumb [uppDataid]="'tabselect-product-' + (tr(_product.name) || '') + '-thumb'"
                        target="TICKET" 
                        [product]="_product"
                        [ticket]="ticket"
                        (Select)="OnSelect($event, false)"
                    ></upp-product-thumb> 
                </upp-grid-item>
            </ng-container>
        </upp-grid>    
    </ng-container>

    <!-- selects grid -->
    <ng-container *ngFor="let _product of browser.products; trackBy: browser.ItemTrack;">
        <upp-grid name="PLACE_SELECT_GRID" *ngIf="ToSelectsGrid(_product)" [hidden]="browser.parent !== _product">
            <ng-container *ngFor="let _select of _product.selects; trackBy: browser.ItemTrack">
                <upp-grid-item>
                    <upp-product-thumb [uppDataid]="'tabselect-direct-' + (tr(_select.name) || '') + '-thumb'"
                        target="DIRECT" 
                        [product]="_product"
                        [direct]="_select"
                        [ticket]="ticket"
                        (Select)="OnSelect($event, false)"
                    ></upp-product-thumb> 
                </upp-grid-item>
            </ng-container>

            <upp-grid-item>
                <upp-product-thumb [uppDataid]="'tabselect-direct-' + (tr(_product.name) || '') + '-thumb'"
                    target="DIRECT" 
                    [product]="_product"
                    [ticket]="ticket"
                    (Select)="OnSelect($event, true)"
                ></upp-product-thumb> 
            </upp-grid-item>
        </upp-grid>
    </ng-container>
</ng-template>

<ng-template #searchgrid>
    <ion-item color="warning" style="margin-top: 4px;">
        <ion-label class="title">{{tr('@place_show_search_results', [ search.criteria ])}}</ion-label> 
        <ion-icon slot="end" name="close-outline" (click)="search.Clear()"></ion-icon>
    </ion-item>

    <upp-grid name="PLACE_SELECT_GRID">
        <ng-container *ngFor="let _product of search.results; trackBy: browser.ItemTrack">
            <upp-grid-item>
                <upp-product-thumb [uppDataid]="'tabselect-product-' + (tr(_product.name) || '') + '-thumb'"
                    target="TICKET" 
                    [product]="_product" 
                    [ticket]="ticket"
                    (Select)="OnSelect($event, false)" 
                ></upp-product-thumb>
            </upp-grid-item>    
        </ng-container>
    </upp-grid>
</ng-template>

<ng-template #menugroupsgrid>
    <upp-grid name="PLACE_SELECT_GRID">
        <upp-grid-item *ngFor="let _group of browser.menugroups; trackBy: browser.ItemTrack">
            <upp-thumb [uppDataid]="'tabselect-menugroup-' + (tr(_group.name) || '') + '-thumb'"
                icon="restaurant-outline"
                [title]="tr(_group.name)"
                (click)="browser.OnMenuGroup(_group)"
            ></upp-thumb>
        </upp-grid-item>
    </upp-grid>

    <ng-container *ngIf="browser.menugroups.length === 0">
        <ng-container [ngTemplateOutlet]="emptyproducts"></ng-container>
    </ng-container>
</ng-template>

<ng-template #menuproductsgrid>
    <upp-grid name="PLACE_SELECT_GRID">
        <ng-container *ngFor="let _product of browser.menugroup?.products; trackBy: browser.ItemTrack">
            <upp-grid-item *ngIf="ToProductsGrid(_product)">
                <upp-product-thumb [uppDataid]="'tabselect-menuproduct-' + (tr(_product.name) || '') + '-thumb'"
                    target="TICKET"
                    [product]="_product"
                    [ticket]="ticket"
                    (Select)="OnSelect($event, false)"
                ></upp-product-thumb>
            </upp-grid-item>
        </ng-container>
    </upp-grid>

    <ng-container *ngIf="(browser.menugroup?.products?.length || 0) === 0">
        <ng-container [ngTemplateOutlet]="emptyproducts"></ng-container>
    </ng-container>
</ng-template>

<ng-template #familyitemsgrid>
    <upp-grid name="PLACE_SELECT_GRID">
        <upp-grid-item *ngIf="place?.ProductCodes || place?.HasCodeScan">
            <upp-product-thumb uppDataid="tabselect-prdno-button" target="PRDNO" (Select)="OnProductCodeSearch()"></upp-product-thumb>
        </upp-grid-item>
        <ng-container *ngFor="let _item of browser.FamilyItems(); trackBy: browser.FamilyItemTrack">
            <upp-grid-item *ngIf="_item.preselect">
                <upp-product-thumb [uppDataid]="'tabselect-direct-' + (tr(_item.preselect.name) || '') + '-thumb'"
                    target="DIRECT"
                    [product]="_item.product"
                    [direct]="_item.preselect"
                    [ticket]="ticket"
                    (Select)="OnSelect($event, false)"
                ></upp-product-thumb>
            </upp-grid-item>
            <upp-grid-item *ngIf="!_item.preselect">
                <upp-product-thumb [uppDataid]="'tabselect-product-' + (tr(_item.product.name) || '') + '-thumb'"
                    target="TICKET"
                    [product]="_item.product"
                    [ticket]="ticket"
                    (Select)="OnSelect($event, false)"
                ></upp-product-thumb>
            </upp-grid-item>
        </ng-container>
    </upp-grid>

    <ng-container *ngIf="browser.FamilyItems().length === 0">
        <ng-container [ngTemplateOutlet]="emptyproducts"></ng-container>
    </ng-container>
</ng-template>

<upp-visible-control mode="fill">
    <upp-application-page>
        <upp-panel lines="hide" [size]="view.Mobile ? 'auto' : 'large'">
            <upp-panel-header>
                <upp-header>
                    <upp-header-content style="width: 100%;">
                        <upp-search uppDataid="tabselect-search" 
                            placeholder="{{tr('@place_product_search')}}" 
                            [(ngModel)]="search.criteria" 
                        ></upp-search>
                    </upp-header-content>

                    <ng-container *ngIf="browser.hasParent">
                        <upp-header-button size="large" uppDataid="tabselect-home-button" (click)="MoveHome()">
                            <ion-icon name="wine-outline"></ion-icon>
                        </upp-header-button>     
                        <upp-header-button size="large" uppDataid="tabselect-back-button" (click)="MoveBack()">
                            <ion-icon name="arrow-back-outline"></ion-icon>
                        </upp-header-button>    
                    </ng-container>

                    <upp-header-button *ngIf="view.Mobile && browser.ShowFamiliesTab"
                        size="large"
                        uppDataid="tabselect-family-options-button"
                        (click)="OnFamilyOptions($event)"
                    >
                        <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                    </upp-header-button>

                    <upp-header-button *ngIf="ticket && view.Mobile" size="large" uppDataid="tabselect-ticket-button" (click)="ShowTicket(true)">
                        <ion-icon name="arrow-forward-outline"></ion-icon>
                    </upp-header-button>
                </upp-header>
            </upp-panel-header>
            <upp-panel-content class="tabselect-body">
                <div class="tabselect-lock-mask" *ngIf="locked" uppDataid="tabselect-cart-lock-mask"></div>

                <ng-container *ngIf="view.Mobile && browser.ShowFamiliesTab">
                    <div class="family-options-overlay" *ngIf="ShowFamilyOptions" (click)="OnFamilyOptions($event)"></div>
                    <div class="family-options-dropdown" [class.visible]="ShowFamilyOptions">
                        <ion-item class="title" lines="none">
                            <ion-label>{{tr('@place_select_family_title')}}</ion-label>
                        </ion-item>
                        <ion-list>
                            <ion-item class="select-family" uppDataid="tabselect-family-view-all" (click)="OnSetDefaultFamily(null)" lines="full">
                                <ion-icon slot="start" name="apps-outline"></ion-icon>
                                <ion-label>{{tr('@place_select_family_all')}}</ion-label>
                                <ion-icon color="success" [hidden]="!browser.IsDefaultFamily(null)" slot="end" name="checkmark-outline"></ion-icon>
                            </ion-item>
                            <ion-item class="select-family"
                                *ngFor="let _family of browser.families; trackBy: browser.ItemTrack"
                                [uppDataid]="'tabselect-family-' + FamilyLabel(_family) + '-view'"
                                (click)="OnSetDefaultFamily(_family)"
                                lines="full"
                            >
                                <div class="icon-box" slot="start">
                                    <img *ngIf="FamilyPhoto(_family)" [src]="FamilyPhoto(_family)" alt="" />
                                    <ion-icon *ngIf="!FamilyPhoto(_family)" name="restaurant-outline"></ion-icon>
                                </div>
                                <ion-label>{{tr('@place_select_family', [ FamilyLabel(_family) ])}}</ion-label>
                                <ion-icon color="success" [hidden]="!browser.IsDefaultFamily(_family)" slot="end" name="checkmark-outline"></ion-icon>
                            </ion-item>
                        </ion-list>
                    </div>
                </ng-container>

                <div class="tabselect-catalog">
                    <upp-scrollable
                        class="family-rail"
                        *ngIf="view.Desktop && browser.ShowFamiliesTab"
                        [scrollbar]="'x'"
                    >
                        <div class="family-tab" [class.light]="view.LightTheme">
                            <div uppDataid="tabselect-family-view-all"
                                class="family-icon"
                                [class.default]="browser.IsDefaultFamily(null)"
                                (click)="OnSetDefaultFamily(null)"
                            >
                                <ion-icon name="apps-outline"></ion-icon>
                            </div>
                            <div *ngFor="let _family of browser.families; trackBy: browser.ItemTrack"
                                [uppDataid]="'tabselect-family-' + FamilyLabel(_family) + '-view'"
                                class="family-icon"
                                [class.default]="browser.IsDefaultFamily(_family)"
                                (click)="OnSetDefaultFamily(_family)"
                            >
                                <img *ngIf="FamilyPhoto(_family)" [src]="FamilyPhoto(_family)" alt="" />
                                <ion-icon *ngIf="!FamilyPhoto(_family)" name="restaurant-outline"></ion-icon>
                            </div>
                        </div>
                    </upp-scrollable>

                    <ng-container *ngIf="(search.Searching !== true) && (browser.products.length === 0) && !browser.ShowFamilyItems">
                        <ng-container [ngTemplateOutlet]="emptyproducts"></ng-container>
                    </ng-container>

                    <upp-scrollable
                        class="tabselect-products"
                        [hidden]="(search.Searching !== true) && (browser.products.length === 0) && !browser.ShowFamilyItems"
                    >
                        <div #scrollable>
                            <div [hidden]="search.Searching === true">
                                <ng-container *ngIf="browser.ShowFamilyItems">
                                    <ng-container [ngTemplateOutlet]="familyitemsgrid"></ng-container>
                                </ng-container>
                                <ng-container *ngIf="!browser.ShowFamilyItems && (browser.menu === null || browser.inFamily)">
                                    <ng-container [ngTemplateOutlet]="productsgrid"></ng-container>
                                </ng-container>
                                <ng-container *ngIf="!browser.ShowFamilyItems && browser.menu !== null && browser.menugroup === null && !browser.inFamily">
                                    <ng-container [ngTemplateOutlet]="menugroupsgrid"></ng-container>
                                </ng-container>
                                <ng-container *ngIf="!browser.ShowFamilyItems && browser.menu !== null && browser.menugroup !== null && !browser.inFamily">
                                    <ng-container [ngTemplateOutlet]="menuproductsgrid"></ng-container>
                                </ng-container>
                            </div>
                            <div [hidden]="search.Searching !== true">
                                <ng-container [ngTemplateOutlet]="searchgrid"></ng-container>
                            </div>
                        </div>
                    </upp-scrollable>
                </div>
            </upp-panel-content>

            <upp-panel-footer *ngIf="ticket && view.Mobile" uppDataid="tabselect-ticket-footer">
                <ion-item class="tabselect-toolbar" lines="none">
                    <ion-label class="ticket-summary" uppTouch (click)="ShowTicket(true)" uppDataid="tabselect-ticket-summary">
                        <span class="title-field">
                            <ion-icon name="cart-outline"></ion-icon>
                            <span class="size">{{ticket.ProductsLength}}</span>
                        </span>
                        <span class="title-field">
                            <span class="price">{{ticket.priceinfo.int}},<span class="decimal">{{ticket.priceinfo.dec}}</span>{{tr('@currency')}}</span>
                        </span>
                    </ion-label>

                    <ion-buttons slot="end" class="ticket-actions">
                        <ion-button uppDataid="tabselect-footer-send-button"
                            mode="md"
                            [disabled]="locked || !ticket.CanSend || ticket.pendpay"
                            (click)="OnFooter($event, 'send')"
                        >
                            <ion-icon slot="icon-only" name="checkmark-circle-outline"></ion-icon>
                        </ion-button>
                        <ion-button uppDataid="tabselect-footer-paycash-button"
                            mode="md"
                            [disabled]="locked || !ticket.CanCash || ticket.pendpay"
                            (click)="OnFooter($event, 'cash')"
                        >
                            <ion-icon slot="icon-only" name="cash-outline"></ion-icon>
                        </ion-button>
                        <ion-button uppDataid="tabselect-footer-paycard-button"
                            mode="md"
                            [disabled]="locked || !ticket.CanCard || ticket.pendpay"
                            (click)="OnFooter($event, 'card')"
                        >
                            <ion-icon slot="icon-only" name="card-outline"></ion-icon>
                        </ion-button>
                    </ion-buttons>
                </ion-item>
            </upp-panel-footer>
        </upp-panel>
    </upp-application-page>
</upp-visible-control>

<upp-product-match *ngIf="ShowMatchPanel"
    [place]="place"
    [initialValue]="MatchBarcode"
    (OnDismiss)="OnMatchPanel($event)"
></upp-product-match>